module.exports = __webpack_public_path__ + "img/general.1b6897a8.svg";